import { Images, Layers, Maximize2, BedDouble } from "lucide-react";
import SmartImage from "./SmartImage";
import blueprintGif from "../assets/pixel/blueprint.gif";
import { STATUS, unitStatus, unitSummary } from "../lib/format";
import { track } from "../metrics/track";
import { useI18n } from "../i18n";
import { useFormat } from "../i18n/format";

export function StatusBadge({ unit }) {
  const { t } = useI18n();
  const status = unitStatus(unit);
  return <span className={`badge badge--${STATUS[status].tone}`}>{t(`unit.status.${status}`)}</span>;
}

export default function UnitCard({ unit, project, onInquire, onOpenGallery }) {
  const { t } = useI18n();
  const f = useFormat();
  const status = unitStatus(unit);
  const sold = status === "prodat";
  const images = unit.imageUrls || [];
  const isApartment = (unit.tip || "stan") === "stan";
  const title = f.unitTitle(unit);

  return (
    <article className={`unit-card ${sold ? "is-sold" : ""}`} data-testid="unit-card">
      <button
        type="button"
        className="unit-card-media"
        onClick={() => {
          if (!images.length) return;
          track("gallery_open", { label: unitSummary(unit, project) });
          onOpenGallery?.(unit);
        }}
        disabled={!images.length}
        aria-label={images.length ? t("unit.viewPlan", { title }) : t("unit.planSoon", { title })}
      >
        <SmartImage src={images[0]} alt={t("unit.planAlt", { title })} placeholder={t("unit.planPlaceholder")} art={blueprintGif} />
        {images.length > 1 && (
          <span className="unit-card-count">
            <Images size={14} /> {images.length}
          </span>
        )}
        <span className="unit-card-status">
          <StatusBadge unit={unit} />
        </span>
      </button>
      <div className="unit-card-body">
        <div className="unit-card-head">
          <h3>{title}</h3>
          {project && <span className="unit-card-lamela">{project.identifier}</span>}
        </div>
        <ul className="unit-card-facts">
          <li>
            <Maximize2 size={16} aria-hidden="true" />
            <span>{f.areaLabel(unit.povrsina)}</span>
          </li>
          {isApartment && unit.struktura && (
            <li>
              <BedDouble size={16} aria-hidden="true" />
              <span>{f.strukturaLabel(unit.struktura)}</span>
            </li>
          )}
          <li>
            <Layers size={16} aria-hidden="true" />
            <span>{f.floorLabel(unit.sprat)}</span>
          </li>
        </ul>
        <div className="unit-card-foot">
          <span className="unit-card-price">{f.priceLabel(unit.cena) || t("unit.priceOnRequest")}</span>
          <button
            type="button"
            className={`btn btn--sm ${sold ? "btn--ghost" : ""}`}
            onClick={() => {
              track("inquiry_open", { label: unitSummary(unit, project) });
              onInquire?.(unit);
            }}
            disabled={sold}
          >
            {sold ? t("unit.sold") : t("unit.inquire")}
          </button>
        </div>
      </div>
    </article>
  );
}
